import { render, staticRenderFns } from "./QuestionTemplate.vue?vue&type=template&id=5b446f28&scoped=true&"
import script from "./QuestionTemplate.vue?vue&type=script&lang=js&"
export * from "./QuestionTemplate.vue?vue&type=script&lang=js&"
import style0 from "./QuestionTemplate.vue?vue&type=style&index=0&id=5b446f28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b446f28",
  null
  
)

export default component.exports